import React from "react";
import Phone from "./Phone";
import { GlobalMetricsProvider } from "./contexts/GlobalMetrics";
import { IslandStateProvider } from "./contexts/IslandState";
import { motion } from "framer-motion";
import { TimerProvider } from "./contexts/Timer";
import { CallProvider } from "./contexts/Call";
import Header from "./Header";

const App = () => {
  return (
    <GlobalMetricsProvider>
      <IslandStateProvider>
        <TimerProvider>
          <CallProvider>
            <div className="w-full my-auto">
              <Header />
              <div className="w-full flex flex-col items-center justify-center ">
                <div className="w-full max-w-6xl px-4">
                  <motion.h1
                    className="font-bold text-5xl md:text-6xl py-1 text-center px-6"
                    initial={{ y: 50, opacity: 0, filter: "blur(10px)" }}
                    animate={{ y: 0, opacity: 1, filter: "blur(0px)" }}
                    transition={{ duration: 1 }}
                  >
                    <span className="bg-gradient-to-b from-black to-gray-400 text-transparent bg-clip-text">
                      Dynamic
                    </span>{" "}
                    <span className="bg-gradient-to-b from-black to-gray-400 text-transparent bg-clip-text">
                      Island
                    </span>
                  </motion.h1>
                </div>
                <div className="relative md:p-4 w-full">
                  <Phone />
                </div>
              </div>
            </div>
          </CallProvider>
        </TimerProvider>
      </IslandStateProvider>
    </GlobalMetricsProvider>
  );
};

export default App;
